import React from "react";
import Weather from "./components/Weather";
import './App.css';

function App() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Weather App</h1>
      <Weather />
    </div>
  );
}

export default App;